import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/cn';
import styles from './Badge.module.css';

export type BadgeVariant = 'neutral' | 'primary' | 'success' | 'warning' | 'danger';
export type BadgeSize = 'sm' | 'md';

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & {
  variant?: BadgeVariant;
  badgeSize?: BadgeSize;
  children?: ReactNode;
};

export function Badge({ variant = 'neutral', badgeSize = 'sm', className, children, ...rest }: BadgeProps) {
  return (
    <span
      className={cn(styles.root, styles[`size_${badgeSize}`], styles[`variant_${variant}`], className)}
      data-tone={variant}
      {...rest}
    >
      {children}
    </span>
  );
}
